"use client"

import { useState, useEffect } from "react"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const ExchangeIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.accent};
`

const Title = styled.h3`
  font-size: 14px;
  font-weight: 500;
`

const CountdownContainer = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 500;
`

const CountdownValue = styled.span`
  color: ${(props) => props.theme.primary};
`

const RatesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const RateItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const RateSymbol = styled.span`
  font-size: 14px;
`

const RateValue = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.value > 0 ? props.theme.success : props.theme.error)};
`

function FundingRate() {
  const [fundingRates, setFundingRates] = useState([
    { symbol: "BTC", rate: 0.0012, nextTime: new Date(Date.now() + 3600000) },
    { symbol: "ETH", rate: 0.0008, nextTime: new Date(Date.now() + 3600000) },
    { symbol: "XRP", rate: -0.0003, nextTime: new Date(Date.now() + 3600000) },
  ])

  const [countdown, setCountdown] = useState("00:00:00")

  // Update countdown timer
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date()
      const nextTime = fundingRates[0].nextTime
      const diff = nextTime.getTime() - now.getTime()

      if (diff <= 0) {
        // Simulate new funding rates when time is up
        setFundingRates((prev) =>
          prev.map((rate) => ({
            ...rate,
            rate: Number.parseFloat((Math.random() * 0.004 - 0.002).toFixed(6)),
            nextTime: new Date(Date.now() + 3600000),
          })),
        )
      } else {
        const hours = Math.floor(diff / (1000 * 60 * 60))
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((diff % (1000 * 60)) / 1000)

        setCountdown(
          `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`,
        )
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [fundingRates])

  return (
    <Container>
      <Header>
        <ExchangeIcon />
        <Title>Funding Rate</Title>
      </Header>

      <CountdownContainer>
        Next funding in: <CountdownValue>{countdown}</CountdownValue>
      </CountdownContainer>

      <RatesList>
        {fundingRates.map((rate) => (
          <RateItem key={rate.symbol}>
            <RateSymbol>{rate.symbol}</RateSymbol>
            <RateValue value={rate.rate}>{rate.rate.toFixed(6)}%</RateValue>
          </RateItem>
        ))}
      </RatesList>
    </Container>
  )
}

export default FundingRate

